<template>
  <!-- Reference: https://1x.antdv.com/components/badge/ -->
  <div
    class="aha-status-badge"
    :class="[statusClass]"
    :style="numberStyle"
    v-tooltip="title"
  >
    <slot />
    <div class="aha-status-badge--dot" v-if="isDotVisible" />
    <div :class="countClass" :style="numberStyle" v-if="isStandaloneCount || isSlotCountVisible">
      {{ countValue }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: { // Customize Badge dot color
      type: String,
      default: null,
    },
    count: { // Number to show in badge
      type: Number,
      default: 0,
    },
    dot: { // Whether to display a red dot instead of count
      type: Boolean,
      default: false,
    },
    offset: { // set offset of the badge dot, like [x, y]
      type: Array,
      default: () => [],
    },
    overflowCount: { // Max count to show
      type: Number,
      default: 99,
    },
    showZero: { // Whether to show badge when count is zero
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'default', // success | processing | default | error | warning
    },
    text: { // If status is set, text sets the display text of the status dot
      type: String,
      default: null,
    },
    numberStyle: { // Sets the display style of "count"
      type: Object,
      default: () => {},
    },
    title: { // Text to show when hovering over the badge
      type: String,
      default: null,
    },
  },

  computed: {
    statusClass() {
      return this.status?.length ? `aha-badge-${this.status}` : ''
    },

    isDotVisible() {
      return !this.count && this.dot
    },

    isSlotEmpty() {
      return !this.$slots.default || this.$slots.default.length === 0
    },

    isStandaloneCount() {
      const isCountZero = this.count === 0
      const baseCondition = this.isSlotEmpty && !this.isDotVisible

      if (isCountZero) {
        return baseCondition && this.showZero
      }
      return baseCondition
    },

    isSlotCountVisible() {
      const isCountZero = this.count === 0
      const baseCondition = !this.isSlotEmpty && !this.isDotVisible

      if (isCountZero) {
        return baseCondition && this.showZero
      }
      return baseCondition
    },

    countClass() {
      return this.isStandaloneCount ? 'aha-status-badge--standalone-count' : 'aha-status-badge--slot-count'
    },

    countValue() {
      if (this.count > this.overflowCount) return `${this.overflowCount}+`
      return this.count
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-status-badge {
  @apply relative;
}
.aha-status-badge--standalone-count {
  @apply w-max bg-red-50 text-base-0;
  height: max-content;
  @apply text-xs border border-transparent px-1 rounded-full;
}
.aha-status-badge--slot-count {
  @apply absolute w-max bg-red-50 text-base-0;
  @apply border border-base-0 text-xs px-1 rounded-full;
  height: max-content;
  top: -5px;
  right: -10px;
}
.aha-status-badge--dot {
  width: 6px;
  height: 6px;
  @apply bg-red-50 rounded-full;
  @apply absolute top-0 right-0 z-1;
  box-shadow: 0 0 0 1px #fff;
  transform: translate(50%, -50%);
  transform-origin: 100% 0;
}

</style>
